import methodHelpers from 'src/utilities/method-helpers';
import { QAGuideProps } from '../types.d';

const QAGuide = ({ active }: QAGuideProps) => {
  const className = methodHelpers.buildClassNames({
    active,
    'tab-content': true
  });
  return (
    <div className={className}>
      <div>
        <h4 className="u-marginVLg my-4 rating-5">2 - Fine</h4>
        <div>
          Response is fine and we would be happy to show this information to a student.
        </div>
        <ul id="fine">
          <li>
            No comments or issue codes required
          </li>
        </ul>
      </div>
      <div>
        <h4 className="u-marginVLg my-4 text-dark-grey">1 - Some issues</h4>
        <div className="u-marginBottomSm mb-2">
          Response is okay but could be better/is not ideal. A ‘some issues’ response is not hugely detrimental
          to the student's experience.
        </div>
        <ul id="some-issues">
          <li>Overly positive/evaluative feedback</li>
          <li>
            Feedback is partially correct (includes anything that would be categorised as a 'do not show' on its own)
          </li>
          <li>
            OOS feedback
          </li>
          <li>
            Repetitive responses
          </li>
          <li>
            LLM demonstrates a lack of understanding
          </li>
          <li>
            Missed referral
          </li>
          <li>
            Double messages
          </li>
        </ul>
      </div>
      <div>
        <h4 className="u-marginVLg my-4 text-danger">0 - Poor</h4>
        <div className="u-marginBottomSm mb-2">
          Response is not appropriate and negatively affects the student’s experience with the service.
        </div>
        <ul id="poor">
          <li>Hallucinations</li>
          <li>Incorrect feedback/gaps in knowledge</li>
          <li>
            Generated assessable content/TAS issue
          </li>
          <li>
            Edited or rewrote student writing
          </li>
          <li>
            Patronising tone/insensitive messages
          </li>
          <li>
            Referrals to competitors
          </li>
        </ul>
      </div>
    </div>
  );
};

export default QAGuide;
